// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 134) return "app-launcher/actiondesk.c0d4cb493ca67ce11897.min.js";
	if (chunkId === 9) return "app-launcher/static.8b2d72cbcc5434f32c82.min.js";
	if (chunkId === 807) return "app-launcher/dynamic-locale-jp-json.97bb6f47bed0a2ce8217.min.js";
	if (chunkId === 138) return "app-launcher/md-editor.bcf587fc76a51a170098.min.js";
	if (chunkId === 176) return "app-launcher/charts.5b70a2751b100ed2b1ff.min.js";
	if (chunkId === 522) return "app-launcher/maps.c8daa7be9c051bfb0914.min.js";
	if (chunkId === 84) return "app-launcher/dendrogram.d41733d5d4eae97d0732.min.js";
	if (chunkId === 77) return "app-launcher/graph.86a1fcfe5d1f66426b16.min.js";
	if (chunkId === 108) return "app-launcher/sankey.83fd4f4f5de9a88f0cf6.min.js";
	if (chunkId === 872) return "app-launcher/872.5dab33f312a44df8b1df.min.js";
	if (chunkId === 272) return "app-launcher/272.dc5f93c6866b24b14433.min.js";
	if (chunkId === 797) return "app-launcher/797.13c2784c87bdd6bdf9f9.min.js";
	if (chunkId === 583) return "app-launcher/583.3c6740f7030729ab37e0.min.js";
	if (chunkId === 630) return "app-launcher/630.bd899174f9c24214f9cb.min.js";
	if (chunkId === 999) return "app-launcher/999.0f60d7db6880000887b1.min.js";
	// return url for filenames based on template
	return undefined;
};